module.exports = __webpack_public_path__ + "static/media/aloharOrange.963544aa.svg";